import { Module, VuexModule, Mutation } from 'vuex-module-decorators'
import { SubcustomerUserSubscription } from '~/graphql/types'

@Module({
  name: 'subcustomer',
  stateFactory: true,
  namespaced: true,
})
export default class Subcustomer extends VuexModule {
  loading = true
  items: SubcustomerUserSubscription['user'] = []

  @Mutation
  setLoading(loading) {
    this.loading = loading
  }

  @Mutation
  setItems(items) {
    this.items = items
  }
}
